import mapping from './mapping';

const customLangParser = (operator, brand) => {
    if (!operator) return; /** let's consider that it loads twice and inside the first load we don`t have operator */

    const { config, operators } = mapping.find(item => item.operators.hasOwnProperty(operator)) || {};

    if (config && operators) {
        const brands = operators[operator];

        if (brands.includes(brand)) {
            return { ...config, target: brand };
        }

        if (operators.hasOwnProperty(operator) && operators[operator].length === 0) {
            return { ...config, target: operator };
        }

        return config;

    } else {
        console.warn(`[bridge] #customLangMapping: Provided operator: ${operator} or brand: ${brand ? brand : 'unknown'} doesn\`t exists in the custom lang mapping, so the custom lang regulation will not be activated... Activating RegulationsFactory `);
        return {};
    }
};

export default customLangParser;